module.exports = __webpack_public_path__ + "img/icon-fslp.cced10a9.png";